import { getUserHadTrial } from '@griply/utils';
import { useUser } from 'shared/hooks/use-user';

export const useUserHadTrial = () => {
  const user = useUser();
  return getUserHadTrial(user);
};
